module.exports = __webpack_public_path__ + "01_cheeks.6a90c912.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer3/01_cheeks.png
// module id = K4Vd
// module chunks = 0